const BIOPSY_NOT_RELATED_TO_ACT = 'biopsyNotRelatedToAct';
export default BIOPSY_NOT_RELATED_TO_ACT;
